'use client'

import { Box, Flex, Icon, Text, FlexProps } from '@chakra-ui/react'
import { HiArrowLeft } from 'react-icons/hi'
import { Link } from '@/components/Link'
import { useSearchParams } from 'next/navigation'
import type { ReadonlyURLSearchParams } from 'next/navigation'

type BackProps = FlexProps

const FEED_SEARCH_URL = '/feeds' as const
const WHITE_LIST = ['q', 'hashtag'] as const
const extractParameterString = (searchParams: ReadonlyURLSearchParams) =>
  WHITE_LIST.map((key) => [key, searchParams.get(key)])
    .filter((pair): pair is [string, string] => pair[1] !== null)
    .map((pair) => `${pair[0]}=${pair[1]}`)
    .join('&')

export const Back = ({ ...flexProps }: BackProps) => {
  const searchParams = useSearchParams()
  const params = extractParameterString(searchParams)
  const url = params ? `${FEED_SEARCH_URL}?${params}` : FEED_SEARCH_URL

  return (
    <Box cursor="pointer">
      <Link href={url}>
        <Flex {...flexProps} alignItems="center" color="black">
          <Icon fontSize={['xl', 'xl', '2xl']} mr={2} as={HiArrowLeft} />
          <Text fontSize={['lg', 'lg', 'xl']} fontWeight="bold">
            戻る
          </Text>
        </Flex>
      </Link>
    </Box>
  )
}
